import { render, staticRenderFns } from "./InvoiceIncomingExtendedRowBaseData.vue?vue&type=template&id=547af32d&scoped=true"
import script from "./InvoiceIncomingExtendedRowBaseData.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvoiceIncomingExtendedRowBaseData.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./InvoiceIncomingExtendedRowBaseData.vue?vue&type=style&index=0&id=547af32d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547af32d",
  null
  
)

export default component.exports